import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getEnvironment } from '@util/functions';

/** Banner height in pixels (padding: 8px * 2 + line-height ~20px) */
export const BANNER_HEIGHT = 36;

const ENVIRONMENT = getEnvironment();
const isProduction = ENVIRONMENT.toUpperCase() === 'PRODUCTION';

export const IS_BANNER_VISIBLE = Boolean(ENVIRONMENT) && !isProduction;

const EnvironmentBanner = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!IS_BANNER_VISIBLE || !mounted) {
    return null;
  }

  return (
    <Banner role="status" aria-label={`${ENVIRONMENT} environment`}>
      <WarningIcon />
      {ENVIRONMENT.toUpperCase()} ENVIRONMENT
      <WarningIcon />
    </Banner>
  );
};

const WarningIcon = () => <span aria-hidden="true">&#9888;</span>;

const Banner = styled.div`
  background-color: ${({ theme }) => theme.brand.primary};
  color: #ffffff;
  text-align: center;
  padding: 8px 15px;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
`;

export default EnvironmentBanner;
